const axios = require('axios').default;

export default function (el) {
  if (el === null) return false;

  const goButton = el.querySelector('.js-nz-form-go');
  const skipButton = el.querySelector('.js-nz-form-skip');
  const skipClass = 'js-nz-form-skip';
  const regoField = el.querySelector('[name="rego"]');
  const validationMessage = el.querySelector('.js-validation-message');

  regoField.addEventListener('input', (event) => {
    if (regoField.value) {
      goButton.classList.add('opacity-100');
      goButton.classList.remove('opacity-50');
      if (validationMessage) validationMessage.textContent = '';
    } else {
      goButton.classList.remove('opacity-100');
      // goButton.classList.add('opacity-50');
    }
  });

  function validateFields() {
    if (!regoField.value) {
      if (validationMessage) validationMessage.textContent = 'Please enter your registration number.';
      return false;
    }
    if (validationMessage) validationMessage.textContent = '';
    return true;
  }

  const dataLayerPush = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
    });
  };

  goButton.addEventListener('click', (event) => {
    event.preventDefault();
    if (validateFields()) {
      el.requestSubmit();
    }
  });

  skipButton.addEventListener('click', (event) => {
    event.preventDefault();
    regoField.value = '';
    el.requestSubmit();
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    dataLayerPush();

    const utmTagsValue = getCookie('utmTags');
    const ACTION = el.getAttribute('action');
    const CLEAN_ACTION = ACTION.split('?')[0];
    const UXE_VALUE = getUxeValueFromAction(ACTION);
    const LOOKUP_DESIRED = event?.submitter?.className?.includes(skipClass)
      ? 0
      : ACTION.includes('lookup=1');

    axios
      .post(
        'https://19ms0ek1c3.execute-api.ap-southeast-2.amazonaws.com/prod/encrypt',
        {
          url: `lookup=${LOOKUP_DESIRED ? 1 : 0}&rego=${regoField.value.replace(/[^a-z0-9]/gi, '')}`,
        }
      )
      .then(function (payload) {
        const { data } = payload.data;

        if (window.location.search) {
          if (UXE_VALUE !== null) {
            window.open(
              `${CLEAN_ACTION}${window.location.search}&UXE=${UXE_VALUE}&enc=${data}`,
              '_self'
            );
          } else {
            window.open(
              `${CLEAN_ACTION}${window.location.search}&enc=${data}`,
              '_self'
            );
          }
        } else if (utmTagsValue !== '') {
          if (UXE_VALUE !== null) {
            window.open(
              `${CLEAN_ACTION}${utmTagsValue}&UXE=${UXE_VALUE}&enc=${data}`,
              '_self'
            );
          } else {
            window.open(
              `${CLEAN_ACTION}${utmTagsValue}&enc=${data}`,
              '_self'
            );
          }
        } else {
          if (UXE_VALUE !== null) {
            window.open(
              `${CLEAN_ACTION}?UXE=${UXE_VALUE}&enc=${data}`,
              '_self'
            );
          } else {
            window.open(`${CLEAN_ACTION}?enc=${data}`, '_self');
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  el.addEventListener('submit', handleSubmit);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (const element of ca) {
      let c = element;
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Get UXE from form endpoint
  function getUxeValueFromAction(action) {
    const regex = /[?&]UXE=([^&]*)/;
    const match = action.match(regex);

    if (match && match.length >= 2) {
      return match[1];
    } else {
      return null;
    }
  }
}
